/**
 * Spec 027: the visitor's own choice of Production on a brand's production website
 * (`/?env=production`), kept in that origin's localStorage. No imports, so both the redirect rules
 * and the runtime target switch can use it without a cycle.
 */
export const BRAND_ENV_CHOICE_KEY = 'brand_env_choice_v1';

export function readProductionChoice(): boolean {
  try {
    return window.localStorage.getItem(BRAND_ENV_CHOICE_KEY) === 'production';
  } catch {
    return false;
  }
}

export function storeProductionChoice(): void {
  try {
    window.localStorage.setItem(BRAND_ENV_CHOICE_KEY, 'production');
  } catch {
    // private mode: the choice lasts only for this page
  }
}

/** The visitor picked Testing again: the brand's default applies. */
export function clearProductionChoice(): void {
  try {
    window.localStorage.removeItem(BRAND_ENV_CHOICE_KEY);
  } catch {
    // ignore
  }
}
